import { render, staticRenderFns } from "./Home2.vue?vue&type=template&id=02402e03&scoped=true&"
import script from "./Home2.vue?vue&type=script&lang=js&"
export * from "./Home2.vue?vue&type=script&lang=js&"
import style0 from "./Home2.vue?vue&type=style&index=0&id=02402e03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02402e03",
  null
  
)

export default component.exports